import { VisitWish } from 'App/ReservationBook/Screens/VisitWishes/visitWishApi';
import { coversDate } from 'App/ReservationBook/Screens/VisitWishes/wishFilters';
import { EditReservation } from 'types/reservations';

export function visitWishReservationDate(wish: VisitWish, today: string, selectedDate?: string) {
  if (selectedDate && selectedDate >= today && coversDate(wish, selectedDate)) return selectedDate;
  const day = new Date(`${wish.dateFrom > today ? wish.dateFrom : today}T12:00:00Z`);
  for (let checked = 0; checked < 800 && Number.isFinite(day.getTime()); checked++) {
    const date = day.toISOString().slice(0, 10);
    if (date > wish.dateTo) return null;
    if (coversDate(wish, date)) return date;
    day.setUTCDate(day.getUTCDate() + 1);
  }
  return null;
}

export function visitWishEditor(wish: VisitWish, date: string, reservationId: string): EditReservation {
  return {
    new: true,
    page: 0,
    date,
    reservationId,
    visitWishId: wish.id,
    tables: null,
    timeSlot: null,
    guests: wish.guests,
    occassion: wish.occassions.length === 1 ? wish.occassions[0] : undefined,
    guest: {
      createNew: true,
      name: wish.contact.name,
      email: wish.contact.email,
      phone: wish.contact.phone ?? '',
      comment: '',
      attr: [],
      preferredLanguage: 'de',
      sendEmail: true,
    },
    sendConfirmationEmail: true,
  };
}
